import React from "react";
import { Button, ButtonProps } from "@blueprintjs/core";
import styled from "styled-components";
import { Colors } from "@blueprintjs/core";

type WrapperProps = {
  bgColor?: string;
  bradius?: string;
  pd?: string;
  width?: string;
  fontSize?: string;
  textColor?: string;
  intent?: "primary" | "success" | "warning" | "danger" | "none";
};

type CustomButtonProps = ButtonProps & WrapperProps;

const StyledButtonWrapper = styled.div<WrapperProps>`
  .bp5-button {
    padding: ${({ pd }) => pd || "0px 10px 0px 15px"};
    width: ${({ width }) => width || "inherit"};
    font-size: ${({ fontSize }) => fontSize || "14px"};
    border-radius: ${({ bradius }) => bradius || "10px"};
    background-color: ${({ intent, bgColor }) => (intent ? "" : bgColor || "")};
    color: ${({ intent, textColor }) => (intent ? "" : textColor || "")};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .bp5-button:disabled, .bp5-button.bp5-disabled  {
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(17, 20, 24, 0.2) !important;
    cursor: not-allowed !important;
  }
`;

const CustomButton: React.FC<CustomButtonProps> = ({
  bgColor,
  bradius,
  pd,
  width,
  fontSize,
  textColor,
  children,
  ...buttonProps
}) => {
  return (
    <StyledButtonWrapper
      bgColor={bgColor}
      bradius={bradius}
      pd={pd}
      width={width}
      fontSize={fontSize}
      textColor={textColor}
      intent={buttonProps.intent}
    >
      <Button {...buttonProps}>{children}</Button>
    </StyledButtonWrapper>
  );
};

export default CustomButton;

// import { Button, Colors } from "@blueprintjs/core";
// import styled from "styled-components";
// const CustomButton = styled(Button)<{ bgColor?: string, bradius?: string, pd?: string, width?: string,fontSize?: string }>`
//   padding: ${({ pd }) => (pd ? pd : "0px 10px 0px 15px")} !important;
//   width:${({ width }) => (width ? width : "inherit")};
//   font-size:${({ fontSize }) => (fontSize ? fontSize : "14px")};
//   border-radius:${({ bradius }) => (bradius ? bradius : "10px")};
//   background-color: ${({ bgColor, theme: { darkMode } }) => (bgColor ? bgColor : darkMode ? Colors.DARK_GRAY4 : Colors.WHITE)} !important;
// `;

// export default CustomButton;
